module.exports = __webpack_public_path__ + "img/ML.9bfa2ac8.svg";